module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8017.13f7a534.png";